"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewerEvent = useViewerEvent;

var _useOsdEventHandler = require("./use-osd-event-handler");

var _useViewerContext2 = require("./use-viewer-context");

function useViewerEvent(eventName, callback) {
  var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useViewerContext = (0, _useViewerContext2.useViewerContext)(),
      viewer = _useViewerContext.viewer,
      isReady = _useViewerContext.isReady;

  (0, _useOsdEventHandler.useOsdEventHandler)(viewer, eventName, callback, active && isReady);
}